<!--  -->
<template>
  <div class='container'>
	<div class="bg" @click="close"></div>
    <div class="posterImg"><img :src="posterImg" alt=""></div>
    <canvas id="post" width="527" height="882" />
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  import Drawer from "../js/canvasutils.js";
  import QRCode from 'qrcode';
  export default {
    name: "poster",
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      //这里存放数据
      return {
        posterImg: ''
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
		close() {
			this.$emit("close")
		},
      creatQrCode() {
        console.log(window)
        //let shareUrl=window.cjwxApi.getShareUrl();
        let shareUrl = window.location.href.split("#")[0]||"http://oylz.xxsbwg.com/#/";
        QRCode.toDataURL(shareUrl, (err, url) => {
          console.log(url)
          this.codeUrl = url;
          this.drawPost(url);
        })

      },
      drawPost(url) {
        console.log(url)
        let drawer = new Drawer.Drawer("post");
        // let w = 684;
        // let h = 1145;
        let w = 527;
        let h = 882;
        let list = [{
            type: "img",
            x: 0,
            y: 0,
            width: w,
            height: h,
            url: require('@/assets/img/bg_poster.png')
          },
          {
            type: "img",
            x: 340,
            y: 655,
            width: 150,
            height: 195,
            url: require('@/assets/img/bg_code.png')
          },
          {
            type: "img",
            x: 360,
            y: 675,
            width: 110,
            height: 110,
            url: url
          },

        ];

        // drawList.push(
        // 	{type:"img",x:(w-mw)/2,y:mapY,url:url,width:mw,height:mh},
        // 	{type:"img",x:qx,y:qy,url:qrurl,width:qw,height:qw},
        // 	{type:"img",x:ax,y:ay,url:avatar,width:aw,height:aw,circle:true},
        // 	{type:"text",text:name,color:"#0063b7",font,fontSize:fontSize,x:nameX,y:nameY},
        // 	{type:"text",text:word,color:"#0063b7",font,fontSize:2.2*rem,x:13.6*rem,y:37.4*rem+offy,vcenter:true,maxWidth:44*rem,lineHeight:2.18*rem},
        // 	{type:"text",text:zanNum,color:"#c00000",font,fontSize:fontSize,x:64*rem+(-zanNumWidth)/2,y:39.5*rem+offy},
        // 	);
        drawer.draw(list, (result, msg) => {
          if (!result)
            window.showToast(msg || "生成海报失败")
          else {
            let cv = document.getElementById("post");
            this.posterImg = cv.toDataURL("image/png");

          }
        })
      },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.creatQrCode();
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='css' scoped>
  .container {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    overflow: hidden;

  }
  .bg {
	position:relative;
	width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    overflow: hidden;
  }

  .posterImg {
	position:absolute;
	z-index:2;
    width: 70.267vw;
    height: 117.6vw;
	left:0;
	top:0;
	right:0;
	bottom:0;
    margin: 20vw auto;
  }

  #post {
    opacity: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/poster.vue